import { iconsImgs } from "../../utils/icons";
import { useState } from "react";
import { useNavigate } from "react-router";
import "./AddFriends.scss";
import Header from "../Header";
import { Friendship, User } from "../../types"
import AddFriendsOptionsModal from "./Modals/AddFriendsOptionsModal";
import UserProfileType from "../../api/enums/UserProfileType";
import { useLocation } from "react-router-dom";
import Gender from "../../api/enums/Gender";

const createFriendId = () => crypto.randomUUID();

const AddGirlsOrBoys = () => {

    const [showModal, setShowModal] = useState(false);
    const handleCloseModal = () => setShowModal(false);

    const location = useLocation();
    const { groupId } = location.state
    const navigate = useNavigate();

    const [femaleCount, setFemaleCount] = useState(0);
    const [maleCount, setMaleCount] = useState(0);

    const handleEditProfileClick = () => {
        const totalCount = femaleCount + maleCount;
        if (totalCount > 0) {
            const friends: User[] = [
                ...Array.from({ length: femaleCount }, (_, i) => ({
                    Id: createFriendId(),
                    FirstName: `Female ${i + 1}`,
                    Age: 0,
                    Gender: Gender.Female,
                    ProfileType: UserProfileType.Unkown,
                    DateOfBirth: new Date(),
                })),
                ...Array.from({ length: maleCount }, (_, i) => ({
                    Id: createFriendId(),
                    FirstName: `Male ${i + 1}`,
                    Age: 0,
                    Gender: Gender.Male,
                    ProfileType: UserProfileType.Unkown,
                    DateOfBirth: new Date(),
                })),
            ];

            const inputs: Friendship = { Friends: friends, GroupId: groupId };

            navigate("/friendsPhotos", {
                state: { inputs, groupId }
            });
        } else {
            setShowModal(true);
        }
    };

    return (
        <>
            <AddFriendsOptionsModal showModal={false} handleCloseModal={() => { }} showWarningModal={showModal} handleCloseWarningModal={handleCloseModal} />
            <Header />
            <div className="centerGroup">
                <div className="desktopUI">
                    <div className="row">
                        <div className="d-flex justify-content-start space col-6 mb-1">
                            <button className='BtnTop yellowTxt btn backBtn' onClick={() => navigate(-1)}>Back</button>
                        </div>

                        <div className="d-flex justify-content-end col-6 space">
                            <button className="BtnTop whiteTxt btn text-decoration-none" onClick={handleEditProfileClick} >
                                Next
                            </button>
                        </div>
                    </div>

                    <div className="container mt-3">
                        <div className="friend-container d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                                <img src={iconsImgs.Girl} className="icon" alt="Female" />
                                <span className="whiteTxt ms-2">Females</span>
                            </div>
                            <div className="d-flex align-items-center">
                                <button
                                    className="btn_ yellowTxt btn text-decoration-none"
                                    onClick={() => setFemaleCount(c => Math.max(0, c - 1))}
                                    disabled={femaleCount === 0}
                                >
                                    -
                                </button>
                                <span className="whiteTxt mx-3">{femaleCount}</span>
                                <button
                                    className="btn_ yellowTxt btn text-decoration-none"
                                    onClick={() => setFemaleCount(c => Math.min(20, c + 1))}
                                    disabled={femaleCount === 20}
                                >
                                    +
                                </button>
                            </div>
                        </div>

                        <div className="friend-container d-flex align-items-center justify-content-between mt-2">
                            <div className="d-flex align-items-center">
                                <img src={iconsImgs.Boy} className="icon" alt="Male" />
                                <span className="whiteTxt ms-2">Males</span>
                            </div>
                            <div className="d-flex align-items-center">
                                <button
                                    className="btn_ yellowTxt btn text-decoration-none"
                                    onClick={() => setMaleCount(c => Math.max(0, c - 1))}
                                    disabled={maleCount === 0}
                                >
                                    -
                                </button>
                                <span className="whiteTxt mx-3">{maleCount}</span>
                                <button
                                    className="btn_ yellowTxt btn text-decoration-none"
                                    onClick={() => setMaleCount(c => Math.min(20, c + 1))}
                                    disabled={maleCount === 20}
                                >
                                    +
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddGirlsOrBoys;
